const stepOne = () => import('@/views/step-one')
const stepTwo = () => import('@/views/step-two')
const stepThree = () => import('@/views/step-three')
const exam = () => import('@/views/exam')
const signin = () => import('@common/views/sign/signin.vue')
const examExplain = () => import('@/views/exam-explain')
const examIng = () => import('@/views/examing')
const examResult = () => import('@/views/exam-result')
const examPass = () => import('@/views/exam-passlist')
const examDetail = () => import('@/views/exam-detail')

const routers = [
  // 估价首页
  {
    path: '/',
    name: 'home',
    component: stepOne
  },
  {
    path: '/signin',
    name: 'signin',
    component: signin
  },
  {
    path: '/login',
    name: 'login',
    component: signin
  },
  // 估价首页
  {
    path: '/step-one',
    name: 'step-one',
    component: stepOne
  },
  // 估价第二步
  {
    path: '/step-two',
    name: 'step-two',
    component: stepTwo
  },
  // 估价结果
  {
    path: '/step-three',
    name: 'step-three',
    component: stepThree
  },
  // 评测说明
  {
    path: '/exam/explain/:id',
    name: 'exam-explain',
    component: examExplain
  },
  // 评测说明
  {
    path: '/exam/result/:id',
    name: 'exam-result',
    component: examResult,
    meta: {requiresAuth: true}
  },
  // 某一评测所有通过者列表，id为套题id
  {
    path: '/exam/pass/:id',
    name: 'exam-pass',
    component: examPass,
    meta: {requiresAuth: true}
  },
  // 评测说明
  {
    path: '/exam/in/:id',
    name: 'exam-in',
    component: examIng,
    meta: {requiresAuth: true}
  },
  // 评测详情
  {
    path: '/exam/:id',
    name: 'exam-detail',
    component: examDetail
  },
  // 评测首页
  {
    path: '/exam',
    name: 'exam',
    component: exam
  }
]
export default routers
